import React from "react";
import "./ContactDetailsForm.scss"; // We'll create this CSS file

export const ContactDetailsForm: React.FC = () => {
  return (
    <div className="contact-form-container">
      {/* Carrier's Name and Contact Details */}
      <div className="form-row header-row">
        <div className="label-cell carrier-name-label">
          <label>Nom du transporteur (carrier's name)</label>
        </div>
        <div className="contact-details-group">
          <div className="label-cell">
            <label>Contact (Contact details)</label>
          </div>
          <div className="contact-sub-row">
            <div className="label-cell sub-label-cell">
              <label>Téléphone (telephone)</label>
            </div>
            <div className="label-cell sub-label-cell">
              <label>Email</label>
            </div>
          </div>
        </div>
      </div>
      <div className="form-row input-row">
        <div className="input-cell full-width"></div>{" "}
        {/* Empty cell for carrier name input */}
        <div className="input-cell"></div>{" "}
        {/* Empty cell for telephone input */}
        <div className="input-cell"></div> {/* Empty cell for email input */}
      </div>

      {/* Carrier's Address */}
      <div className="form-row full-width-row">
        <div className="label-cell full-width-label">
          <label>Adresse du transporteur (Carrier's address)</label>
        </div>
      </div>
      <div className="form-row full-width-row input-row">
        <div className="input-cell full-width"></div>{" "}
        {/* Empty cell for carrier address input */}
      </div>

      {/* Contact Person */}
      <div className="form-row header-row">
        <div className="label-cell contact-person-label">
          <label>Personne à contacter (Contact person)</label>
        </div>
        <div className="contact-details-group">
          <div className="label-cell">
            <label>Contact (Contact details)</label>
          </div>
          <div className="contact-sub-row">
            <div className="label-cell sub-label-cell">
              <label>Téléphone (telephone)</label>
            </div>
            <div className="label-cell sub-label-cell">
              <label>Email</label>
            </div>
          </div>
        </div>
      </div>
      <div className="form-row input-row">
        <div className="input-cell full-width"></div>{" "}
        {/* Empty cell for contact person input */}
        <div className="input-cell"></div>{" "}
        {/* Empty cell for telephone input */}
        <div className="input-cell"></div> {/* Empty cell for email input */}
      </div>

      {/* DRC Representative */}
      <div className="form-row header-row">
        <div className="label-cell drc-representative-label">
          <label>Nom du représentant en RDC (DRC Representative's Name)</label>
        </div>
        <div className="contact-details-group">
          <div className="label-cell">
            <label>Contact (Contact details)</label>
          </div>
          <div className="contact-sub-row">
            <div className="label-cell sub-label-cell">
              <label>Téléphone (telephone)</label>
            </div>
            <div className="label-cell sub-label-cell">
              <label>Email</label>
            </div>
          </div>
        </div>
      </div>
      <div className="form-row input-row">
        <div className="input-cell full-width"></div>{" "}
        {/* Empty cell for DRC rep name input */}
        <div className="input-cell"></div>{" "}
        {/* Empty cell for telephone input */}
        <div className="input-cell"></div> {/* Empty cell for email input */}
      </div>
    </div>
  );
};
